import { render, staticRenderFns } from "./birthdayRuleEdit.vue?vue&type=template&id=32fc1379&scoped=true&"
import script from "./birthdayRuleEdit.vue?vue&type=script&lang=js&"
export * from "./birthdayRuleEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fc1379",
  null
  
)

export default component.exports